import React from "react";
import { useStore as useAuthStore } from "auth/store";
import { useGetBuildingsCityReportQuery } from "core/queries/GetBuildingsCityReport";
import { useGetBuildingsMetricsQuery } from "core/queries/GetBuildingsMetrics";
import { useAppSelector } from "core/store";
import { CityMetricsList } from "reports/components/CityMetricsList";
import { ReportsList } from "reports/components/ReportsList";
import { ReportsViewContentLoader } from "reports/components/ReportsViewContentLoader";
import { ServiceUnavailableView } from "reports/components/ServiceUnavailableView";
import {
  getServiceUnavailableError,
  getTaskMetricsFilterInput,
} from "reports/utils";
import { useStore as useTasksStore } from "tasks/store";

export const ReportsBuildingView = () => {
  const { state: authState } = useAuthStore();
  const { state: tasksState } = useTasksStore();
  const dateEndAt = useAppSelector(state => state.reports.dateEndAt);
  const dateStartAt = useAppSelector(state => state.reports.dateStartAt);

  const cityId = authState.user?.cityId;

  const sharedVariables = {
    skip: !cityId || !dateEndAt || !dateStartAt,
    variables: {
      filter: getTaskMetricsFilterInput(
        authState,
        dateEndAt,
        dateStartAt,
        tasksState,
      ),
    },
  };

  const { data, error, loading } =
    useGetBuildingsCityReportQuery(sharedVariables);
  const {
    data: metricsData,
    error: metricsError,
    loading: metricsLoading,
  } = useGetBuildingsMetricsQuery(sharedVariables);

  const isServiceUnavailable =
    getServiceUnavailableError(error) ||
    getServiceUnavailableError(metricsError);

  if (isServiceUnavailable) return <ServiceUnavailableView />;
  if (loading || metricsLoading) return <ReportsViewContentLoader />;

  const cityMetrics = data?.cityTaskMetrics?.cityMetrics || [];
  const metricsTable = metricsData?.cityTaskMetrics?.buildingMetrics;

  return (
    <>
      <CityMetricsList cityMetrics={cityMetrics} />
      {metricsTable && <ReportsList metricTable={metricsTable} />}
    </>
  );
};
